<template>
  <a-card :bordered="false" class="m-b-20">
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
        <a-week-picker v-else-if="search.search_date_type=='2'" @change="changeWeek" v-model:value="weekTime" />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" valueFormat='YYYY-MM' format='YYYY-MM' />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <div class="data-content-nav s_flex_ali">
      <div class="data-content-nav-item flex_1 s_flex_center" :class="active==v.id?'active':''" @click="changNav(v.id)" v-for="(v,k) in TBAS" :key="k">
        <div>
          <p class='title'>{{v.title}}</p>
          <p class='num'>{{statistics_data[v.key]}}</p>
        </div>
      </div>
    </div>
    <div ref="echartsLine" style="width:100%;height:400px"></div>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <loginOverview :channel_visitor_data="channel_visitor_data" :list="list" />
  </a-card>
  <a-card :bordered="false">
    <transactionConversion :statistics_data="statistics_data" />
  </a-card>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import loginOverview from "./components/loginOverview";
import transactionConversion from "./components/transactionConversion";
import { statisticsUer, statisticsUerChart } from "@/api/online";
import { message } from "ant-design-vue";
const TBAS = [
  {
    title: "访客数",
    key: "uv",
    id: 1,
  },
  {
    title: "浏览数",
    key: "pv",
    id: 2,
  },
  {
    title: "支付积分",
    key: "pay_order_point_price",
    id: 3,
  },
  {
    title: "支付订单数",
    key: "pay_order_nums",
    id: 4,
  },
  {
    title: "支付人数",
    key: "pay_user_nums",
    id: 5,
  },
  {
    title: "客单价",
    key: "user_unit_price",
    id: 6,
  },
  {
    title: "成功退款积分数",
    key: "refund_point_price",
    id: 7,
  },
];
export default {
  components: { loginOverview, transactionConversion },
  setup() {
    const search = ref({
      search_date_type: "1",
      search_time: "",
    });
    const state = reactive({
      active: "1",
      statistics_data: {},
      channel_visitor_data: {},
      list: [],
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd } = useTime();
    const onSearch = () => {
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      initData();
      changNav(state.active);
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = dateTargets();
          break;
        case "2":
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
            dateTime.weekTime=typeToStartEnd("week").end_time
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          break;
      }
    };
    // 切换周
    const momentTime = inject("momentTime");
    const changeWeek = (weekData) => {
      console.log(weekData);
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    const changeQuarter = (e) => {
      console.log(e);
    };
    const initData = async () => {
      let result = await statisticsUer(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      state.statistics_data = result.data.statistics_data;
      state.channel_visitor_data = result.data.channel_visitor_data;
      state.list = [
        {
          name: "门店",
          count: result.data.channel_visitor_data.store_count,
          loginTotal: result.data.channel_visitor_data.store_uv,
          proportion: result.data.channel_visitor_data.store_proportion,
        },
        {
          name: "经销商",
          count: result.data.channel_visitor_data.dealer_count,
          loginTotal: result.data.channel_visitor_data.dealer_uv,
          proportion: result.data.channel_visitor_data.dealer_proportion,
        },
      ];
    };
    const getLine = async () => {
      let result = await statisticsUerChart({
        ...search.value,
        data_type: state.active,
      })
        .then((res) => res.data)
        .catch((error) => error);
      return result.data;
    };
    // 线性图表
    const echartsLine = ref("");
    var line;
    const changNav = async (e) => {
      state.active = e;
      var lines = await getLine();
      line.setOptions({
        tooltip: {
          trigger: "axis",
          formatter: `{b}<br/>${TBAS[Number(state.active)-1].title}：{c}`,
        },
        xAxis: {
          type: "category",
          data: Object.keys(lines),
        },
        yAxis: {
          name: "数据",
          type: "value",
        },
        series: [
          {
            data: Object.values(lines),
            type: "line",
            smooth: true,
          },
        ],
      });
    };
    onMounted(() => {
      handleChange("1");
      initData();
      line = useECharts(echartsLine.value);
      changNav(1);
    });
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      changNav,
      onSearch,
      changeQuarter,
      changeWeek,
      TBAS,
      echartsLine,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
</style>